import React from "react";
import Wrapper from "../../../components/Wrapper/Wrapper";
import { Box, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getProjectCategories } from "../../../redux/features/mastersSlice";
import { useState } from "react";
import { PROJECT_CATEGORIES_TABLE_HEAD } from "../../../components/Masters/ProjectCategoriesTableHead";
import { AddProjectClassPopup } from "../../../components/Masters/AddProjectClassPopup";
import { AddProjectCategoryPopup } from "../../../components/Masters/AddProjectCategoryPopup";

export default function ProjectCategories() {
    const dispatch = useDispatch();
    const [gridSize, setGridSize] = useState(5);
    const { projectCategories, loading } = useSelector(
        (state) => state.masters
    );

    useEffect(() => {
        dispatch(getProjectCategories());
    }, []);
    return (
        <div>
            <Wrapper
                title="Project Categories"
                actions={<AddProjectCategoryPopup />}
                Content={
                    <>
                        <Paper elevation={3}>
                            <Box sx={{ width: "100%", padding: 0 }}>
                                <DataGrid
                                    components={{ Toolbar: CustomGridToolbar }}
                                    loading={loading}
                                    autoHeight
                                    sx={{
                                        "& .MuiDataGrid-columnHeaderTitle": {
                                            textOverflow: "clip",
                                            whiteSpace: "break-spaces",
                                            lineHeight: 1,
                                        },
                                    }}
                                    getRowHeight={() => "auto"}
                                    rows={projectCategories}
                                    columns={PROJECT_CATEGORIES_TABLE_HEAD}
                                    getRowId={(row) => row.serialNumber}
                                    pageSize={gridSize}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    onPageSizeChange={(newGridSize) =>
                                        setGridSize(newGridSize)
                                    }
                                />
                            </Box>
                        </Paper>
                    </>
                }
            />
        </div>
    );
}
